module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-211-retro.d0954fee.jpg";